import React from "react";
import "./cubix.css";
import Particles from "../../Particles/Particles";
import HeroSection from "./HeroSection";
import FeaturesOnServices from "./FeaturesOnServices";
import OurApproach from "./OurApproach";
import Technologies from "./Technologies";
import CallToAction from "./CallToAction";

const Cubix = () => {
  return (
    <>
      <Particles title="Cubix" />
      <HeroSection />
      <FeaturesOnServices />
      <OurApproach />
      <Technologies />
      <CallToAction />
    </>
  );
};

export default Cubix;
